const getQueryParameterByName = require('../helpers/GetQueryParam');

const customer = getQueryParameterByName('custrec');
const channel = getQueryParameterByName('channel');
const uid = getQueryParameterByName('uid');
const sku = getQueryParameterByName('sku');
const smi = getQueryParameterByName('smi');
const readOnly = !customer && !uid;

const customerName = getQueryParameterByName('custname') || '';
const customerAddress = getQueryParameterByName('custaddress') || '';
const customerCity = getQueryParameterByName('custcity') || '';
const customerState = getQueryParameterByName('custstate') || '';
const customerZip = getQueryParameterByName('custzip') || '';
const customerPhone = getQueryParameterByName('custphone') || '';

const promoCode = getQueryParameterByName('promo_code');

// @TODO: add prod endpoint when available
const addToCartUrl = __PROD__ ?
  ''
  : 'https://rest.sandbox.netsuite.com/app/site/hosting/restlet.nl?script=236&deploy=1';

const NetSuiteLoader = {
  productId: getQueryParameterByName('ucid'),
  configId: getQueryParameterByName('config'),
  customer,
  channel: smi || btoa(channel),
  schoolCode: smi,
  addToCartUrl,
  uid,
  sku,
  readOnly,
  customerName,
  customerAddress,
  customerCity,
  customerState,
  customerZip,
  customerPhone,
  promoCode
};

if (smi) {
  NetSuiteLoader.schoolCode = smi;
}

export default NetSuiteLoader;



// WEBPACK FOOTER //
// ./src/base/scripts/loaders/netsuite.js